import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E1ED044C-BD73-4844-A33D-7ED9A1D232F5
 * name tooltip-plus
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-plus.svg
 * tags
 * - Tooltip 
 */
export const TooltipPlusIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z" /></>, 'TooltipPlusIcon');
export default TooltipPlusIcon